import { FunctionComponent } from 'react';
import {
  Card,
  Layout,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  TextContainer,
} from '@shopify/polaris';
import styled from 'styled-components';
import { CardTitleSmall } from '@components/ui/common';

const Container = styled.div`
  .Polaris-SkeletonPage__Header {
    display: none;
  }

  .Polaris-SkeletonPage__Page {
    padding: 0;
  }
`;

const PageSkeleton: FunctionComponent<{
  pageTitle?: string;
  secondaryTitle?: string;
  isSectionedLayout?: boolean;
  cardTitles?: string[];
}> = (props) => {
  const { cardTitles, isSectionedLayout, pageTitle, secondaryTitle } = props;

  return (
    <Container>
      <SkeletonPage fullWidth>
        <Layout>
          <Layout.Section>
            <Card sectioned title={pageTitle}>
              <SkeletonBodyText />
            </Card>
            {cardTitles &&
              cardTitles.map((title) => (
                <Card title={title} sectioned key={title}>
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText />
                  </TextContainer>
                </Card>
              ))}
          </Layout.Section>
          {isSectionedLayout && (
            <Layout.Section secondary>
              <Card title={<CardTitleSmall>{secondaryTitle}</CardTitleSmall>}>
                <Card.Section>
                  <TextContainer>
                    <SkeletonBodyText lines={3} />
                  </TextContainer>
                </Card.Section>
              </Card>
            </Layout.Section>
          )}
        </Layout>
      </SkeletonPage>
    </Container>
  );
};

export default PageSkeleton;
